import React from 'react';
import { 
  CheckCircle, 
  Cancel, 
  Schedule, 
  Info,
  Warning,
  HourglassEmpty,
  RotateLeft
} from '@mui/icons-material';
import { Chip, alpha } from '@mui/material';

/**
 * Retorna a cor correspondente ao status da fatura para uso em Chips do MUI ou outros elementos
 */
export const getInvoiceStatusColor = (status: string): "success" | "warning" | "error" | "info" | "default" | "primary" | "secondary" => {
  switch (status?.toLowerCase()) {
    case 'pago':
      return 'success';
    case 'parcialmente_pago':
      return 'warning';
    case 'cancelado':
      return 'default';
    case 'vencido':
      return 'error';
    case 'aberto':
      return 'info';
    default:
      return 'default';
  }
};

/**
 * Retorna o rótulo amigável para o status da fatura
 */
export const getInvoiceStatusLabel = (status: string): string => {
  const labels: Record<string, string> = {
    pago: 'Pago',
    parcialmente_pago: 'Parcialmente Pago',
    cancelado: 'Cancelado',
    vencido: 'Vencido',
    aberto: 'Aberto',
  };
  return labels[status?.toLowerCase()] || status;
};

/**
 * Retorna o ícone correspondente ao status da fatura
 */
export const getInvoiceStatusIcon = (status: string, fontSize: 'small' | 'inherit' | 'medium' | 'large' = 'small') => {
  switch (status?.toLowerCase()) {
    case 'pago':
      return <CheckCircle fontSize={fontSize} />;
    case 'parcialmente_pago':
      return <RotateLeft fontSize={fontSize} />;
    case 'cancelado':
      return <Cancel fontSize={fontSize} />;
    case 'vencido':
      return <Info fontSize={fontSize} />;
    case 'aberto':
      return <HourglassEmpty fontSize={fontSize} />;
    default:
      return <Info fontSize={fontSize} />;
  }
};

/**
 * Retorna um componente Chip estilizado de acordo com o status
 */
export const InvoiceStatusChip = ({ status, size = 'small' }: { status: string, size?: 'small' | 'medium' }) => {
  const label = getInvoiceStatusLabel(status);
  
  const colors: Record<string, string> = {
    pago: '#2e7d32', // success
    parcialmente_pago: '#ed6c02', // warning
    cancelado: '#9e9e9e', // default
    vencido: '#d32f2f', // error
    aberto: '#0288d1', // info
  };

  const color = colors[status?.toLowerCase()] || '#9e9e9e';

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        bgcolor: alpha(color, 0.1),
        color: color,
        fontWeight: 700,
        fontSize: size === 'small' ? '0.7rem' : '0.8rem',
        height: size === 'small' ? 22 : 28,
        border: `1px solid ${alpha(color, 0.2)}`,
        '& .MuiChip-label': {
          px: 1,
        }
      }}
    />
  );
};
